import { PlusOutlined } from '@ant-design/icons'
import { Button, Form } from 'antd'
import { FC } from 'react'
import MaterialRow from '../material-row/material-row'
import { MaterialTypeOption } from '../types'

interface MaterialsListProps {
    typeOptions: { value: string; label: string }[]
    types: MaterialTypeOption[]
}

const MaterialsList: FC<MaterialsListProps> = ({ typeOptions, types }) => {
    return (
        <Form.List
            name="materials"
            rules={[
                {
                    validator: async (_, materials) => {
                        if (!materials?.length) {
                            throw new Error('Добавьте хотя бы один материал')
                        }
                    },
                },
            ]}
        >
            {(fields, { add, remove }, { errors }) => (
                <>
                    <div style={{ marginBottom: 8, fontWeight: 500 }}>Материалы</div>

                    {fields.map(({ key, name, ...rest }) => (
                        <MaterialRow
                            key={key}
                            name={name}
                            rest={rest}
                            typeOptions={typeOptions}
                            types={types}
                            canRemove={fields.length > 1}
                            onRemove={() => remove(name)}
                        />
                    ))}

                    <Form.ErrorList errors={errors} />

                    <Button type="dashed" onClick={() => add({})} icon={<PlusOutlined />} block>
                        Добавить материал
                    </Button>
                </>
            )}
        </Form.List>
    )
}

export default MaterialsList